import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import CurrencyConverter from '../../CurrencyConverter';
import ToolTipSection from '../../Common/ToolTipSection/ToolTipSection';

// Helper
import paymentDetailsHelper from '../../../helpers/paymentDetailsHelper';
import { getPromoCodeDetailsValue } from '../../../helpers/GetDynamicItemName/dynamicHomeValue';

// Locale
import messages from '../../../locale/jsonMessages';

//Image

import cs from '../../commonStyle.css';
import s from '../ViewMessage.css';

const PaymentDetails = (props) => {

	const { startDate, endDate, basePrice, delivery, currency, monthlyDiscount, weeklyDiscount, userType, endTime, startTime } = props;
	const { checkOutDifference, openModal } = props;
	const { reservationData } = props;
	const { formatMessage, locale } = useIntl();
	const { promoCode, promoDiscount, promoCodeType, promoCodeDescription, dynamicPromoCodeDetails } = reservationData || {}

	let {
		guestServiceFee, hostServiceFee, isSpecialPriceAssigned, priceForDays, dayDifference,
		claimStatus, securityDeposit, claimAmount, claimPayout, isDelivery, discount, total,
		isDayTotal, isDiscount, isDiscountType, isAverage, discountType, totalWithoutServiceFee,
		hostEarnings
	} = paymentDetailsHelper({
		monthlyDiscount, weeklyDiscount, userType,
		reservationData, startTime, endTime, startDate, endDate, basePrice, promoDiscount, promoCodeType
	});

	const promoCodeDetails = JSON.parse(dynamicPromoCodeDetails || '[]');
	const dynamicValue = getPromoCodeDetailsValue(promoCodeDetails, locale);

	return (
		<div className={cx(s.cancelDetailsContainer)}>
			<div>
				<hr className={s.billingLine} />
				<h4 className={cx(s.space3, s.marginTop0, s.tripDetails)}>
					<span><FormattedMessage {...messages.billing} /></span>
				</h4>
			</div>

			<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
				<div className={cx(cs.commonSmallText16, cs.textStart)}>
					<div className='tooltipFlex'>
						{isSpecialPriceAssigned && <ToolTipSection label={formatMessage(messages.averageRate)}
							tooltipIconClass={cx(cs.positionRelative, cs.top3)} />}
						<div>
							<CurrencyConverter amount={isAverage} from={currency} />
							<span className={cs.displayinlineBlock}>&nbsp;{'x'}&nbsp;&rlm;{dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}</span>
						</div>
					</div>
				</div>
				<div className={cx(cs.commonSmallText16, cs.textEnd)}>
					<CurrencyConverter amount={priceForDays} from={currency} />
				</div>
			</div>

			{
				discount > 0 &&
				<div className={cx(cs.dataTableGrid, cs.paymentDivider, 'discountText')}>
					<div className={cx(cs.commonSmallText16, cs.textStart)}>{discountType}</div>
					<div className={cx(cs.commonSmallText16, cs.textEnd)}>
						<span>-&nbsp; <CurrencyConverter amount={discount} from={currency} /> </span>
					</div>
				</div>
			}

			{
				promoDiscount > 0 && (userType == 'renter' || userType == 'owner' && promoCodeType == 'host') &&
				<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
					<div className={cx(cs.commonSmallText16, cs.textStart)}>
						<div className="tooltipFlex">
							<ToolTipSection label={dynamicValue?.description ? dynamicValue?.description : promoCodeDescription} tooltipIconClass={cx(cs.positionRelative, cs.top3)} />
							<span className='discountText'>{promoCode}</span>
						</div>
					</div>
					<div className={cx(cs.commonSmallText16, cs.textEnd, 'discountText')}>
						<span>-&nbsp; <CurrencyConverter amount={promoDiscount} from={currency} /></span>
					</div>
				</div>
			}


			{
				delivery > 0 && isDelivery > 0 &&
				<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
					<div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.cleaningFee} /></div>
					<div className={cx(cs.commonSmallText16, cs.textEnd)}>
						<CurrencyConverter amount={isDelivery} from={currency} />
					</div>
				</div>
			}

			{
				userType === 'renter' && guestServiceFee > 0 &&
				<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
					<div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.serviceFee} /></div>
					<div className={cx(cs.commonSmallText16, cs.textEnd)}>
						<CurrencyConverter amount={guestServiceFee} from={currency} />
					</div>
				</div>
			}

			{
				userType === 'owner' && hostServiceFee > 0 &&
				<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
					<div className={cx(cs.commonSmallText16, cs.textStart)}>
						<FormattedMessage {...messages.serviceFee} />
					</div>
					<div className={cx(cs.commonSmallText16, cs.textEnd)}>
						<span>-&nbsp; <CurrencyConverter amount={hostServiceFee} from={currency} /></span>
					</div>
				</div>
			}

			{
				userType === 'renter' && securityDeposit > 0 &&
				<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
					<div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.securityDeposit} /></div>
					<div className={cx(cs.commonSmallText16, cs.textEnd)}>
						<CurrencyConverter amount={securityDeposit} from={currency} />
					</div>
				</div>
			}

			<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
				<div className={cx(cs.textStart, userType === 'renter' && [cs.commonSmallText18, cs.fontWeightBold],
					userType === 'owner' && [cs.commonSmallText16])}>
					<FormattedMessage {...messages.subTotal} />
				</div>
				<div className={cx(cs.commonSmallText16, cs.textEnd)}>
					<CurrencyConverter amount={total} from={currency} />
				</div>
			</div>


			{
				userType === 'owner' &&
				<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
					<div className={cx(cs.commonSmallText18, cs.fontWeightBold, cs.textStart)}>
						<FormattedMessage {...messages.youEarn} />
					</div>
					<div className={cx(cs.commonSmallText18, cs.fontWeightBold, cs.textEnd)}>
						<CurrencyConverter amount={hostEarnings} from={currency} />
					</div>
				</div>
			}
			{
				userType === 'owner' && securityDeposit > 0 &&
				<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
					<div className={cx(cs.commonSmallText16, cs.textStart)}>
						<FormattedMessage {...messages.securityDepositByRenter} />
						{
							claimStatus == 'pending' && checkOutDifference > 0 && checkOutDifference < 24 &&
							<div className={cs.spaceTop1}>
								<a className={cx(s.link, s.linkBgColor)} onClick={openModal}>{' ('}<FormattedMessage {...messages.claimDamage} />{')'}</a>
							</div>}
						{
							claimAmount > 0 &&
							<div className={cs.spaceTop1}>
								<a className={cx(s.link, s.linkBgColor)} onClick={openModal}>{' ('}<FormattedMessage {...messages.claimDetails} />{')'}</a>
							</div>}
					</div>
					<div className={cx(cs.commonSmallText16, cs.textEnd)}>
						<CurrencyConverter amount={securityDeposit} from={currency} />
					</div>
				</div>
			}
			{
				userType === 'owner' && claimStatus === 'approved' && claimPayout > 0 &&
				<div className={cx(cs.dataTableGrid)}>
					<div className={cx(cs.commonSmallText16, cs.textStart)}>
						<FormattedMessage {...messages.securityDepositAmountToHost} />
					</div>
					<div className={cx(cs.commonSmallText16, cs.textEnd)}>
						<CurrencyConverter amount={claimPayout} from={reservationData && reservationData.currency} />
					</div>
				</div>
			}
		</div>
	);
}

PaymentDetails.propTypes = {
	formatMessage: PropTypes.any,
	userType: PropTypes.string.isRequired,
	basePrice: PropTypes.number.isRequired,
	delivery: PropTypes.number.isRequired,
	monthlyDiscount: PropTypes.number,
	weeklyDiscount: PropTypes.number,
	currency: PropTypes.string.isRequired,
	startDate: PropTypes.string.isRequired,
	endDate: PropTypes.string.isRequired,
	serviceFees: PropTypes.shape({
		guest: PropTypes.shape({
			type: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired,
			currency: PropTypes.string.isRequired
		}).isRequired,
		host: PropTypes.shape({
			type: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired,
			currency: PropTypes.string.isRequired
		}).isRequired
	}).isRequired
};

PaymentDetails.defaultProps = {
	startDate: null,
	endDate: null,
	basePrice: 0,
	delivery: 0,
	monthlyDiscount: 0,
	weeklyDiscount: 0
};
export default withStyles(cs, s)(PaymentDetails);

